import { MantineProvider } from "@mantine/core";
import { GoogleOAuthProvider } from "@react-oauth/google";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import App from "./Containers/App/App";
import { setupStore } from "./Store/store";
import { DefaultTheme } from "./Theme/defaultTheme";

import "@mantine/core/styles.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const store = setupStore();

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={DefaultTheme}>
        <Provider store={store}>
          <GoogleOAuthProvider
            clientId={
              "86935402230-5f0kf5aq2pq1tr698f8u13ctg2vm2vt9.apps.googleusercontent.com"
            }
          >
            <MantineProvider>
              <App />
            </MantineProvider>
          </GoogleOAuthProvider>
        </Provider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
